module.exports = __webpack_public_path__ + "df29ff4a0aa2b97009d2733b523be41c.svg";